"use strict";
var errorObject_1 = require('./errorObject');
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map


//////////////////
// WEBPACK FOOTER
// C:/thinkbit/conference/hosting/~/rxjs/util/tryCatch.js
// module id = ../../../../rxjs/util/tryCatch.js
// module chunks = 22